import { render, staticRenderFns } from "./RotorSailTotals.vue?vue&type=template&id=21999c22&"
import script from "./RotorSailTotals.vue?vue&type=script&lang=js&"
export * from "./RotorSailTotals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports